import { render, staticRenderFns } from "./ReturnIcon.vue?vue&type=template&id=35c4e11d&scoped=true&"
import script from "./ReturnIcon.vue?vue&type=script&lang=js&"
export * from "./ReturnIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReturnIcon.vue?vue&type=style&index=0&id=35c4e11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4e11d",
  null
  
)

export default component.exports